<template>
<!--
大框：K线图和时分图  style="height:100%;overflow:hidden;"
-->
<div class="z-main">
	<!-- 头部数据 z-common-header z-flex-->
	<header class="z-header">
		<div>
			<router-link to="/">
				<img class="hearIcon" src="../../assets/sysbars/left.png">
			</router-link>
		</div>
		<!-- <div style="color:#E2B96F;">QLC走势(1美金=1QLC)</div> -->
    <div style="color:#000;">1美元横盘</div>
		<div>
		</div>
	</header>
	<div class="z-body z-body-bottom2 z-body-noscroll">
		<!-- 选择类型 -->
		<div class="z-flex z-Kline-times dark-color">
			<span v-for="(item,index) in timeArr"
					@click="timeChooseEven(item)"
					:class="item.type==chooseTimeType ? 'z-Kline-active' : ''"
					v-text="item.text">
			</span>
		</div>
		<!-- K线图页面 -->
		<div :style="{height: eh+'px'}" id="k-line" class="z-mk-line"></div>

		<!-- 加载动画 -->
		<div v-if="isLoading" class="z-loading">
			<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
		</div>
	</div>

</div>
</template>

<script>
import { mInit,mAppend,kInit,kAppend } from "../../plugins/echarts.js";
export default {
	name: "Kline",
	data() {
		return {
			timeArr: [ //K线时间类型数组
				// { type: "1M", text: "1分" },
				{ type: "5M", text: "5分" },
				{ type: "10M", text: "10分" },
				{ type: "15M", text: "15分" },
				{ type: "30M", text: "30分" },
				{ type: "1H", text: "时K" },
				// { type: "D", text: "日K" },
				// { type: "W", text: "周K" },
				// { type: "M", text: "月K" },
			],
			chooseTimeType:"15M",//默认K线时间类型
			chooseTimeText: "15分",//默认K线时间类型文本
			fid:10,//合约id
			kIsFirst:true,//K线是否第一次加载，有加载过则不重复加载，只做数据追加，如果未加载，则加载
			eh:500,//图表高度
			kChart:null,//K线图表对象
			kOption:null,//K线图配置
			isLoading:true,//是否加载中
		};
	},
	inject:['reload'],
	computed: {
	},
	created() {
		let _this = this
	},

	mounted() {
		let _this = this;
		_this.getKdata()
	},
	destroyed(){
		let _this = this;
    	clearInterval(_this.kInterval)
	},
	watch: {
		"$store.state.chooseTimeType": {
			handler: function(newType) {
				let chooseTimeType = this.$store.state.chooseTimeType;
				for (const item of this.timeArr) {
					if (chooseTimeType === item.type) {
						this.chooseTimeText = item.text;
						break;
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		setEchartsBoxHeight(elId){//设置图表div高度
			let _this = this
			let h = document.body.clientHeight
			_this.eh = h-300
			let el = document.getElementById(elId)
			let son = el.getElementsByTagName('div')[0]
			son.style.height='100%'
			son.style.width='100%'
			let canvas = son.getElementsByTagName('canvas')[0]
			canvas.style.height='100%'
			canvas.style.width='100%'
		},
		getKdata(){ //获取K线数据
			let _this = this;
			//显示加载
			_this.isLoading = true
			//异步数据
			_this.get('api/Quotations/Line',{
				fid: _this.fid,
				period:_this.chooseTimeType
			})
			.then(function(rs) {
				if (rs.code==0) {
					_this.$nextTick(()=>{
						//设置非一次
						_this.kIsFirst = false
						//图表初始化
						kInit(rs.data)

						//设置宽高
						_this.setEchartsBoxHeight('k-line')

						//隐藏加载
						_this.isLoading = false
					})
				}
				else {
					//隐藏加载
					_this.isLoading = false
				}
			})
			.catch(function(err) {
				//隐藏加载
				_this.isLoading = false
			})
		},
		timeChooseEven(item) { //K线时间类型选择
			let _this = this
			_this.chooseTimeText = item.text
			_this.chooseTimeType = item.type
			_this.getKdata()
		},
	}
};
</script>

<style scoped>
.z-Kline-header{
	height: 60px;
	font-size: 18px;
	color: white;
	padding:0 10px;
	justify-content:space-between;
	background-color: #28293D;
	border-bottom:1px solid #424355;
}
.z-echarts-box {
	overflow: hidden;
  	height: 100%;
}
/* 最新价格 start*/
.z-new {
	position: relative;
	display: flex;
	display: -webkit-flex;
	justify-content: flex-start;
	background-color: #20232A;
	width: 100vw;
	height: 80px;
	padding: 10px 0px;
	border-bottom: 1px solid #1E1F22;
}
.z-new-item {
	width: 50%;
}
.z-new-item img{
	width: 25px;
	height: 25px;
}
.z-new-item-1 {
	display: flex;
	display: -webkit-flex;
	justify-content:center;
}
.z-new-item-1 div:first-child{
	display: flex;
	display: -webkit-flex;
	flex-direction:column;
	width: 50%;
	text-align: center;
}
.z-new-item-1 div:nth-child(2) {
	display: flex;
	display: -webkit-flex;
	align-items:center;
	width: 20%;
}

.z-new-item-2 div{
	display: flex;
	display: -webkit-flex;
	flex-direction:row;
	justify-content:space-around;
	color:#898989;
	font-size: 12px;
	width: 100%;
	padding: 5px 0px;
}
.z-new-item-2 div>span:nth-child(1),
.z-new-item-2 div>span:nth-child(3){
	width: 20%;
}
.z-new-item-2 div>span:nth-child(2),
.z-new-item-2 div>span:nth-child(4){
	width: 30%;
}
/* 最新价格 end*/

/* 分时图和K线图高度 START*/
.z-mk-line {
	width:100%;
	touch-action: pan-y;
    user-select: none;
    -webkit-user-drag: none;
    /* padding-bottom: 60px; */
}
.z-loading{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
	display: flex;
    display: -webkit-flex;
    align-items:center;
    justify-content:center;
}
/* 分时图和K线图高度 END*/


.hearIcon {
width: 20px;
height: 20px;
}
.time-choose-menu {
width: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
}
.time-choose-menu p {
margin: 0;
width: 100%;
text-align: center;
height: 25px;
}
.z-Kline-times{
	color:#9B9A99;
	font-size: 14px;
	padding: 10px;
}
.z-Kline-active {
	color: #E2B96F;
	border-bottom: 3px solid #E2B96F;
}
.z-Kline-trade{
    background: #21222B;
	padding: 10px;
	justify-content:center;
	font-size: 18px;
	border-top: 1px solid #282932;
	height: 47px;
	width: 100%;
}
.z-Kline-trade img{
	width: 20px;
}
/* 权益 */
.z-kline-qy {
	display: flex;
    display: -webkit-flex;
    align-items:center;
    justify-content:space-around;
    background: #525257;
    padding: 10px;
    margin-bottom: 10px;
}
/* 选择 */
.z-kline-buy-select {
	display: flex;
    display: -webkit-flex;
    align-items:center;
    justify-content:space-around;
    border:1px solid #6B6B6B;
    width: 90%;
    margin: 0 auto;
    padding: 8px 5px;
    border-radius: 5px;
}
.z-kline-buy-select div:nth-child(1) input{
	width: 60%;
	outline:none;
}
.z-kline-buy-select div:nth-child(1) {
	border-right:1px solid #6B6B6B;
	display: flex;
    display: -webkit-flex;
	align-items:center;
}
.z-kline-buy-select div:nth-child(1) img{
	width: 20px;
	height: 20px;
}
.z-kline-buy-select div:nth-child(2) {
	text-align: center;
	width: 30%;
}
.z-kline-buy-select div:nth-child(2) img{
	width: 10px;
	height: 10px;
}
.z-kline-buy-dialog {
	display: flex;
    display: -webkit-flex;
    align-items:center;
    justify-content:space-around;
    flex-direction:column;
	background: white;
	width: 100%;
	color: #282834;

}
.z-kline-buy-dialog div {
	padding: 8px;
	width: 80%;
	text-align: center;
}
.z-kline-buy-dialog img {
	width: 10px;
	height: 10px;
}
.z-kline-buy-dialog div:nth-child(1),
.z-kline-buy-dialog div:last-child{
	color:#ABABAB;
}
.z-kline-buy-dialog div:last-child{
	text-align: right;
}
.z-buy-model-select {
	color:#E2B96F;
}
/* 按钮 */
.z-kline-btns {
	display: flex;
    display: -webkit-flex;
    align-items:center;
    justify-content:space-between;
    width: 90%;
    margin:10px auto;
}
.z-kline-btns div {
	width: 46%;
	border-radius: 5px;
	text-align: center;
	padding: 10px;
}
.z-kline-btns div:nth-child(1){
	background: #DF0712;
}
.z-kline-btns div:nth-child(2){
	background: #05D209;
}
.z-kline-bottom {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #20232A;
}
</style>



// WEBPACK FOOTER //
// src/pages/futures/dollar.vue